import Logo from './images/logo.png';
import Banner_1 from './images/banner_1.jpg';
import Banner_2 from './images/banner_2.jpg';
import payOption1 from './images/pay1.png';
import payOption2 from './images/pay2.png';
import payOption3 from './images/pay3.png';
import payOption4 from './images/pay4.png';
import icon1 from './images/icons/icon1.png';
import icon2 from './images/icons/icon2.png';
import icon3 from './images/icons/icon3.png';
import polygonBG from './images/polygon-bg.png';
import process1 from './images/image1.jpg';
import process2 from './images/image2.jpg';
import prod1 from './images/prod1.png';
import prod2 from './images/prod2.png';
import prod3 from './images/prod3.png';
import technology1 from './images/icons/android.jpg';
import technology2 from './images/icons/angular.jpg';
import technology3 from './images/icons/html.jpg';
import technology4 from './images/icons/ios.jpg';
import technology5 from './images/icons/php.jpg';
import technology6 from './images/icons/react.jpg';
import user1 from './images/user1.jpg';
import award1 from './images/award1.png';

export const images = {
    Logo, Banner_1, Banner_2, payOption1, payOption2, payOption3, payOption4, icon1, icon2, icon3, polygonBG, process1, process2, prod1, prod2, prod3, technology1, technology2, technology3, technology4, technology5, technology6, user1, award1
}